<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.EDIT' | translate }} - {{ eventGroupSeo?.name }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body p-0 d-flex flex-column">
  <form
    id="event-group-seo-form"
    (ngSubmit)="save()"
    [formGroup]="form"
    novalidate
    class="d-flex overflow-hidden flex-grow-1"
  >
    <ng-scrollbar class="locales-menu ps">
      <div class="modal-section-title mt-2 mb-2 ps-2">
        {{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.WEBSITES_LIST_TITLE' | translate }}
      </div>

      <div
        *ngFor="let websiteLocale of companyWebsiteLocales"
        (click)="selectCompanyWebSiteLocale(websiteLocale.id)"
        class="website-locale d-flex"
        [ngClass]="{ active: currentWebsiteLocaleId === websiteLocale.id }"
      >
        <div class="ico">
          <i class="fal fa-chevron-right"></i>
        </div>
        <div class="name">{{ websiteLocale.website.name }} - {{ websiteLocale.website.url }}</div>
        <div class="flag">
          <span class="flag-icon" [ngClass]="'flag-icon-' + websiteLocale.locale.locale"></span>
        </div>
      </div>
    </ng-scrollbar>

    <div class="flex-grow-1 overflow-auto">
      <div class="locales-content-wrapper" formArrayName="websiteLocales">
        <div *ngIf="!currentWebsiteLocaleId" class="modal-section-title ps-3 mt-2">
          {{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.SELECT_WEBSITE_MSG' | translate }}
        </div>

        <div *ngFor="let websiteLocale of form.get('websiteLocales')?.controls; let i = index" class="locales-content">
          <div
            [formGroupName]="i"
            *ngIf="currentWebsiteLocaleId === websiteLocale.get('company_website_locale_id').value"
          >
            <div class="modal-section-title mt-2 mb-2">
              {{ getWebsiteLocaleName(websiteLocale.get('company_website_locale_id').value) }}
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.SLOGAN' | translate }}</label>
                <input type="text" class="form-control" formControlName="slogan" />
              </div>
            </div>

            <div class="form-group">
              <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.DESCRIPTION' | translate }}</label>
              <app-editor
                [form]="websiteLocale"
                passFormControlName="description"
                [attrs]="{ min_height: 200 }"
              ></app-editor>
            </div>

            <div class="form-group">
              <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.EXTENDED_DESCRIPTION' | translate }}</label>
              <app-editor
                [form]="websiteLocale"
                passFormControlName="extended_description"
                [attrs]="{ min_height: 200 }"
              ></app-editor>
            </div>

            <div class="form-group">
              <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.SLUG' | translate }}</label>
              <input type="text" class="form-control" formControlName="slug" />
            </div>

            <div class="form-group">
              <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.META_TITLE' | translate }}</label>
              <input type="text" class="form-control" formControlName="meta_title" />
            </div>

            <div class="form-group">
              <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.META_DESCRIPTION' | translate }}</label>
              <input type="text" class="form-control" formControlName="meta_description" />
            </div>

            <div class="form-group">
              <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.VIDEO_URL' | translate }}</label>
              <input type="text" class="form-control" formControlName="video_url" />
            </div>

            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                [attr.id]="'event-group-seo-active-' + websiteLocale.get('company_website_locale_id').value + '-' + i"
                formControlName="active"
              />
              <label
                class="custom-control-label"
                [attr.for]="'event-group-seo-active-' + websiteLocale.get('company_website_locale_id').value + '-' + i"
              >
                {{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.ACTIVE' | translate }}
              </label>
            </div>

            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                [attr.id]="'event-group-seo-top-' + websiteLocale.get('company_website_locale_id').value + '-' + i"
                formControlName="top"
              />
              <label
                class="custom-control-label"
                [attr.for]="'event-group-seo-top-' + websiteLocale.get('company_website_locale_id').value + '-' + i"
              >
                {{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.TOP' | translate }}
              </label>
            </div>

            <div class="modal-section-title mt-2">{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.FACTS' | translate }}</div>

            <div class="facts-wrapper" formArrayName="facts">
              <div *ngFor="let fact of websiteLocale.get('facts')?.controls; let j = index">
                <div class="single-fact row" [formGroupName]="j">
                  <div class="col-sm-3">
                    <div class="form-group">
                      <div class="d-flex justify-content-between">
                        <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.ICON' | translate }}</label>
                        <a class="btn-link" href="https://fontawesome.com/v4.7.0/cheatsheet/" target="_blank">link</a>
                      </div>
                      <input type="text" class="form-control" formControlName="icon" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="form-group">
                      <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.COUNT' | translate }}</label>
                      <input type="text" class="form-control" formControlName="count" />
                    </div>
                  </div>

                  <div class="col-sm-7">
                    <div class="form-group">
                      <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.LABEL' | translate }}</label>
                      <input type="text" class="form-control" formControlName="label" />
                    </div>
                  </div>

                  <button type="button" class="remove-fact" (click)="removeFact(websiteLocale, j)">
                    <i class="fal fa-times"></i>
                  </button>
                </div>
              </div>

              <button class="btn btn-input btn-outline-primary" type="button" (click)="addFact(websiteLocale)">
                {{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.ADD' | translate }}
              </button>
            </div>

            <div class="modal-section-title mt-2">{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.TABS' | translate }}</div>

            <div class="tabs-wrapper" formArrayName="tabs">
              <div *ngFor="let tab of websiteLocale.get('tabs')?.controls; let k = index">
                <div class="single-tab row" [formGroupName]="k">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.TITLE' | translate }}</label>
                      <input type="text" class="form-control" formControlName="title" />
                    </div>
                  </div>

                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>{{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.DESCRIPTION' | translate }}</label>

                      <app-editor
                        [form]="tab"
                        passFormControlName="description"
                        [attrs]="{ min_height: 200 }"
                      ></app-editor>
                    </div>
                  </div>

                  <button type="button" class="remove-tab" (click)="removeTab(websiteLocale, k)">
                    <i class="fal fa-times"></i>
                  </button>
                </div>
              </div>

              <button class="btn btn-input btn-outline-primary" type="button" (click)="addTab(websiteLocale)">
                {{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.ADD' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="event-group-seo-form" [disabled]="form.invalid">
    {{ 'EVENT_GROUPS.EVENT_GROUPS_SEO_FORM.SAVE' | translate }}
  </button>
</div>
